/* RESPONSIBLE TEAM: team-messenger */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class AvailabilitySerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    customResponseTimeValues: {
      serialize: false,
      deserialize: 'records',
    },
    customResponseDelayOptions: {
      serialize: false,
      deserialize: 'records',
    },
    hasDefaultOfficeHoursIntervals: {
      serialize: false,
    },
  };
}
